import React from 'react';

export default p => {
  return (
    <div>
      {p.message} {p.inTwoLine ? <div><br /></div> : null} {p.unitNumber} {p.streetNumber}  {p.streetDirection} {p.streetName} {p.streetType} {p.city}  {p.province}  {p.country}  {p.postCode}
    </div>
  );
};

